const mutations = {
	getData(state) {
		state.result[2].name = "1000";
	}
}

export default mutations;


// WEBPACK FOOTER //
// ./src/store/mutations.js